import React from 'react'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import QualificationLayout from 'src/components/QualificationLayout'
import QualificationSideBar from 'src/components/QualificationSideBar'
import QualificationSideBarMobile from 'src/components/QualificationSideBar/Mobile'
import { useMobile } from 'src/hooks/Mobile'
import Failure from 'src/components/Failure'

const ShowFailure: React.FC = (): React.ReactElement => {
  const { asset, application } = useApplicationDetails()
  const isMobile = useMobile()

  const renderSideBarBlock = (): React.ReactElement | undefined => {
    return (
      <>
        {!isMobile && <QualificationSideBar asset={asset} application={application.application} />}
        {isMobile && (
          <QualificationSideBarMobile asset={asset} application={application.application} />
        )}
      </>
    )
  }
  return (
    <QualificationLayout
      primaryFullWidth
      BlockMain={<Failure />}
      BlockSidebar={renderSideBarBlock()}
    />
  )
}

export default ShowFailure
